import { FadeUp } from '../primitives/FadeUp';
import { SectionH2 } from '../primitives/SectionH2';
import { FeaturesByCategory } from '../middle/FeaturesByCategory';
import { useIsMobile } from '../../hooks/useIsMobile';
import { TEXT_SECONDARY } from '../../tokens';

/** Wraps the tabbed feature catalogue in its own page section. */
export function FeaturesSection() {
  const isMobile = useIsMobile();

  return (
    <section
      id="features"
      style={{ padding: isMobile ? '60px 20px' : '100px 64px', background: 'rgba(6,6,6,0.88)' }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <FadeUp>
          <div style={{ marginBottom: 28 }}>
            <SectionH2 style={{ marginBottom: 8 }}>Everything the system actually does.</SectionH2>
            <p
              style={{
                color: TEXT_SECONDARY,
                fontSize: '1rem',
                lineHeight: 1.75,
                maxWidth: 600,
                marginBottom: 28,
              }}
            >
              Every piece of this exists because something was being lost without it. The mechanism is on
              the left, and what it actually changes for the business is on the right.
            </p>
          </div>
          <FeaturesByCategory />
        </FadeUp>
      </div>
    </section>
  );
}
